import { createSelector } from '@reduxjs/toolkit';

import {
  FilterGridType,
  FilterRootGridType,
  IFilterGridItem,
} from '@/interfaces/constructor.interfaces';
import instanceOfGrid from '@/utils/instanceOfGrid';

import filterGridSelector from './filterGrid';

const getFilterGridItems = (
  filterGroup: FilterRootGridType | FilterGridType,
): Array<IFilterGridItem> => {
  return filterGroup.items.reduce<Array<IFilterGridItem>>((acc, item) => {
    if (instanceOfGrid(item)) {
      return [...acc, ...getFilterGridItems(item)];
    }
    return [...acc, item];
  }, []);
};

/**
 * Получить фильтры из настроек приложения
 */
const flattenFilterGridItemsSelector = createSelector(filterGridSelector, filters => {
  return getFilterGridItems(filters);
});

export default flattenFilterGridItemsSelector;
